import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600">
        <li>
          <Link
            to="/"
            className="hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            <i className="ri-home-4-line"></i>
            <span>首页</span>
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.to ? (
              <Link
                to={item.to}
                className="hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}